export default function () {
  return {
    memberOffers: null,
    isLoading: false,
  };
}
